import React, { useState, useMemo } from "react";
import _ from "lodash";

// components
import ActiveSubmissionsBars from "@/components/ActiveSubmissionsBars";
import DashboardModuleCard from "@/components/DashboardModuleCard";

// helpers
import { statuses } from "@/helpers/statuses";
import SubmissionsTableDrawer from "@/components/SubmissionsTableDrawer";

import { useGetMySubmission } from "../useGetMySubmission";

const MySubmissions = () => {
  const [toggleDrawer, setToggleDrawer] = useState({
    open: false,
    type: null,
    data: null
  });

  const {
    data: mySubmissions,
    isLoading: isLoadingSubmissions,
    doFetch: fetchMySubmissions,
    jobStatus,
    setJobStatus
  } = useGetMySubmission();

  const groupedSubmissions = useMemo(() => {
    return [
      {
        status: "Select Recruit",
        submissions: !mySubmissions
          ? []
          : mySubmissions?.filter((submission) => {
              // console.log({ sub: submission.status, label: statuses.SELECT_RECRUIT.bhLabel });
              return submission.status === statuses.SELECT_RECRUIT.bhLabel;
            })
      },

      {
        status: "Variner Pursuing",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter(
              (submission) => submission.status === statuses.VARINER_PURSUING.bhLabel
            )
      },

      {
        status: "Pending Interest",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter(
              (submission) => submission.status === statuses.PENDING_INTEREST.bhLabel
            )
      },

      {
        status: "Confirmed Interest",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter(
              (submission) => submission.status === statuses.CONFIRMED_INTEREST.bhLabel
            )
      },

      {
        status: "Client Submission",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter(
              (submission) => submission.status === statuses.CLIENT_SUBMISSION.bhLabel
            )
      },

      {
        status: "Interviewing",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter((submission) =>
              _.includes(
                [
                  statuses.INITIAL_INTERVIEW.bhLabel,
                  statuses.SECOND_INTERVIEW.bhLabel,
                  statuses.FINAL_INTERVIEW.bhLabel
                ],
                submission.status
              )
            )
      },

      {
        status: "Holding Pattern",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter(
              (submission) => submission.status === statuses.HOLDING_PATTERN.bhLabel
            )
      },

      {
        status: "No Response",
        submissions: !mySubmissions
          ? []
          : mySubmissions.filter((submission) =>
              _.includes(
                [
                  statuses.NEW_LEAD.bhLabel,
                  statuses.WEB_RESPONSE_ACCEPTED.bhLabel,
                  statuses.INTERNALLY_SUBMITTED.bhLabel
                ],
                submission.status
              )
            )
      }
    ];
  }, [mySubmissions]);

  const highestTotal = useMemo(() => {
    const grouped = _.groupBy(mySubmissions, "status");

    return _.max(Object.values(grouped).map((a) => a.length));
  }, [mySubmissions]);

  return (
    <>
      {groupedSubmissions && (
        <DashboardModuleCard
          title="My Submissions"
          refresh
          // @TODO review dispatch.submissions.fetchActiveSubmissionsBySender usage.
          // onRefresh={() => dispatch.submissions.fetchActiveSubmissionsBySender()}
          onRefresh={fetchMySubmissions}
          refreshing={isLoadingSubmissions}
          bottomContent={
            <ActiveSubmissionsBars
              setToggleDrawer={setToggleDrawer}
              groupedSubmissions={groupedSubmissions}
              highestTotal={highestTotal}
              loading={isLoadingSubmissions}
            />
          }
          jobStatus={jobStatus}
          setJobStatus={setJobStatus}
        />
      )}

      <SubmissionsTableDrawer
        componentTitle="Active Submissions"
        data={groupedSubmissions}
        open={toggleDrawer}
        toggleDrawer={setToggleDrawer}
      />
    </>
  );
};

export { MySubmissions };
